import GuidanceRegistry from '../guidance-registry.js';

GuidanceRegistry.register({
    type: "action-item-ewf-guided-setup-eligibility",
    prompt: "Set your new hire eligibility period and other plan eligibility information. Click Save.",
    briefDescription: 'Eligibility',
    beforeLoad: async (component, guidanceItem) => {
        await component.$store.dispatch("plans/load", {employerId: guidanceItem.employerId, refreshSameEmployer: true});
    },
    openAction: {
        text: "View Plan Eligibility",
        url: (guidanceItem) => `/employer/${guidanceItem.employerId}/plans?planId=${guidanceItem.parameters.planId}`,
        row: "Eligibility"
    },
    completeAction: {
    }
});


// WEBPACK FOOTER //
// ./src/guidance/items/guidance-eligibility.js